import { action } from 'typesafe-actions';

import { IKnmSearchClipped } from 'APIPackage/KnmSearchModule/interfaces/IKnmSearchClipped';
import { ExportFormatsEnum } from 'APIPackage/ImportExportModule/enums/ExportFormatsEnum';
import { IKnmSupervisionTypeSelectOption } from 'CorePackage/CatalogsModule/interfaces/IKnmSupervisionTypeSelectOption';

import { KnmSearchActionsEnum } from '../enums/KnmSearchActionsEnum';
import { IKnmSearchInitFilter } from '../interfaces/IKnmSearchInitFilter';
import { ISupervisionTypeSelectOption } from '../../../CorePackage/CatalogsModule/interfaces/ISupervisionTypeSelectOption';

export const knmSearchResetPage = () => action(KnmSearchActionsEnum.KNM_SEARCH_RESET_PAGE);
export const knmSearchGetData = () => action(KnmSearchActionsEnum.KNM_SEARCH_GET_DATA);
export const knmSearchSetData = (knms: IKnmSearchClipped[], page: number, pageCount: number, totalCount: number) =>
  action(KnmSearchActionsEnum.KNM_SEARCH_SET_DATA, { knms, page, pageCount, totalCount });
export const knmSearchGetDataNextPage = () => action(KnmSearchActionsEnum.KNM_SEARCH_GET_DATA_NEXT_PAGE);
export const knmSearchSetOrder = (order: string) => action(KnmSearchActionsEnum.KNM_SEARCH_SET_ORDER, { order });
export const knmSearchSetFilter = (filter: Partial<IKnmSearchInitFilter>) =>
  action(KnmSearchActionsEnum.KNM_SEARCH_SET_FILTER, { filter });
export const knmSearchSetSearchString = (searchString?: string) =>
  action(KnmSearchActionsEnum.KNM_SEARCH_SET_SEARCH_STRING, { searchString });
export const knmSearchLoadFile = (format: ExportFormatsEnum) =>
  action(KnmSearchActionsEnum.KNM_SEARCH_LOAD_FILE, { format });
export const knmSearchInit = () => action(KnmSearchActionsEnum.KNM_SEARCH_INIT);
export const knmSearchGetKnmSupervisionTypesOptionsAll = () =>
  action(KnmSearchActionsEnum.KNM_SEARCH_GET_KNM_SUPERVISION_TYPES_OPTIONS_ALL);
export const knmSearchSetKnmSupervisionTypesOptionsAll = (
  knmSupervisionTypesOptionsAll: IKnmSupervisionTypeSelectOption[],
) => action(KnmSearchActionsEnum.KNM_SEARCH_SET_KNM_SUPERVISION_TYPES_OPTIONS_ALL, { knmSupervisionTypesOptionsAll });
export const knmSearchGetKnmSupervisionTypesErvkOptionsAll = () =>
  action(KnmSearchActionsEnum.KNM_SEARCH_GET_KNM_SUPERVISION_TYPES_ERVK_OPTIONS_ALL);
export const knmSearchSetKnmSupervisionTypesErvkOptionsAll = (
  knmSupervisionTypesErvkOptionsAll: ISupervisionTypeSelectOption[],
) =>
  action(KnmSearchActionsEnum.KNM_SEARCH_SET_KNM_SUPERVISION_TYPES_ERVK_OPTIONS_ALL, {
    knmSupervisionTypesErvkOptionsAll,
  });
